export const environment = {
  environment: 'test',
  production: true,
  accountService: 'https://tst-cms.avery.com/account',
  appDomain: 'https://tst-cms.avery.com',
  navDomain: 'https://tst-cms.avery.com/avylib/dist/assets',
  authKey: 'wwjH7clZ8E5v5BsgCqQ5zHYf9OlZ8dCB',
  bazaarVoice:
    'https://apps.bazaarvoice.com/deployments/averyproducts-1/main_site/staging/en_US/bv.js',
  braintree: 'https://tst-cms.avery.com/braintree',
  demandBase:
    'https://api.demandbase.com/api/v2/ip.json?key=bd38bd2672863d51e8e5dda8ca51dba2b99f302a',
  domain: 'https://tst-cms.avery.com',
  apiOrigin: 'https://tst-cms.avery.com',
  dpo3: 'https://dpotest.print.avery.com/dpp/public/v3',
  dpo4: 'https://dpotest.print.avery.com/dpp/public/v4',
  dpo5: 'https://dpotest.print.avery.com/dpp/public/v5',
  dpoDeploymentID: 'US_en',
  dpoDomain: 'https://dpotest.print.avery.com',
  dpoDownloadables: 'https://dpotest.print.avery.com/dpp/public/v3/content/downloadables',
  elasticSearch: 'https://search-tst.avery.com',
  image: 'https://img.avery.com',
  labelsEmail: 'https://ixntcv9013.execute-api.us-east-1.amazonaws.com/dev/email',
  magento: 'https://tst-cart.avery.com',
  sampleService: 'https://tst-cms.avery.com/sample',
  ssoService: 'https://tst-cms.avery.com/authenticate',
  W2GI: 'https://hosted.where2getit.com/avery/productlocator.html?sku=',
};

export const config = {
  authKey: 'wwjH7clZ8E5v5BsgCqQ5zHYf9OlZ8dCB',
  env: 'tst',
  recaptchaKey: '6LebcxMsAAAAAKZm8NuNkOBCNh3g7tbcswgITfom',
  recaptchaSecret: '6LebcxMsAAAAAITYGLVOEbcuECgufyuPJWLE7lzf',
  theme: {
    cookieKey: 'avythmmde',
    modes: {
      default: {
        landingPage: environment.domain,
        toggleLabel: 'Avery',
      },
    },
  },
  version: require('../../package.json').version,
};
